import React from "react";
import { Button, ButtonGroup, Form, Modal, Table } from "react-bootstrap";

import { withTranslation } from "react-i18next";
import APIErrorHelper from "../../../../../../helpers/APIErrorHelper";
import CamplaCoreService from "../../../../../../services/CamplaCoreService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faCircleNotch, faTrash } from "@fortawesome/free-solid-svg-icons";
import ConfirmationDialog from "../../../../../../components/dialogs/confirmationDialog/ConfirmationDialog";

class ManagePaperNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showConfirmationDialog: false,
      dialogApiError: ""
    };

    this.handleUpload = this.handleUpload.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  async handleUpload(event) {
    this.setState({ isLoading: true });
    try {
      await CamplaCoreService.uploadPaperNotes(
        this.props.examination._id,
        event.target.files[0]
      );
      const paperNotes = await CamplaCoreService.getAllPaperNotes(
        this.props.examination._id
      );
      this.props.onPaperNotesUpdate(paperNotes);
      this.setState({ isLoading: false });
    } catch (err) {
      this.setState({
        isLoading: false,
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  async handleRemove() {
    try {
      await CamplaCoreService.deletePaperNotes(this.props.examination._id);
      this.props.onPaperNotesUpdate([]);
      this.setState({ showConfirmationDialog: false });
      this.props.onHide();
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  async handleDownload() {
    try {
      await CamplaCoreService.downloadAllPaperNotes(
        this.props.examination._id,
        `${this.props.examination.name}-notes.pdf`
      );
    } catch (err) {
      this.setState({
        dialogApiError: APIErrorHelper.getError(
          err,
          () => this.setState({ dialogApiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  render() {
    const { t } = this.props;
    const paperNotes =
      this.props.hasPaperNotes && !this.state.isLoading ? (
        <Table borderless>
          <tbody>
          <tr>
            <td>
              {t(
                "SingleExamination.InstanceTab.PaperNotesDialog.AlreadyUploaded"
              )}
            </td>
            <td>
              <b>
                {this.props.paperNotes.size - 1}/
                {this.props.examination.instancesCount}
              </b>
              <span className="ml-1">
                  {t(
                    "SingleExamination.InstanceTab.PaperNotesDialog.Recognized"
                  )}
                </span>
            </td>
            <td style={{ float: "right" }}>
              <ButtonGroup aria-label="">
                <Button
                  onClick={this.handleDownload}
                  className="btn btn-green"
                >
                  <FontAwesomeIcon icon={faDownload} />
                </Button>
                <Button
                  onClick={() => this.setState({ showConfirmationDialog: true })}
                  className="btn btn-red"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </ButtonGroup>
            </td>
          </tr>
          </tbody>
        </Table>
      ) : (
        ""
      );
    const upload =
      !this.props.hasPaperNotes && !this.state.isLoading ? (
        <Form>
          <img
            alt={t(
              "SingleExamination.InstanceTab.PaperNotesDialog.Description"
            )}
            src="/images/help/paperNotesInfo.png"
            className="mx-auto d-block"
            width="80%"
          />
          <br />
          <span>
            <b>1. </b>
            {t(
              "SingleExamination.InstanceTab.PaperNotesDialog.DescriptionList.Step1"
            )}
          </span>
          <br />
          <span>
            <b>2. </b>
            {t(
              "SingleExamination.InstanceTab.PaperNotesDialog.DescriptionList.Step2"
            )}
          </span>
          <br />
          <span>
            <b>3. </b>
            {t(
              "SingleExamination.InstanceTab.PaperNotesDialog.DescriptionList.Step3"
            )}
          </span>
          <br />
          <span>
            <b>4. </b>
            {t(
              "SingleExamination.InstanceTab.PaperNotesDialog.DescriptionList.Step4"
            )}
          </span>
          <br />
          <span>
            <b>5. </b>
            {t(
              "SingleExamination.InstanceTab.PaperNotesDialog.DescriptionList.Step5"
            )}
          </span>
          <br />
          <br />
          <Form.File id="custom-file" label="Custom file input" custom>
            <Form.File.Input
              onChange={this.handleUpload}
              accept="application/pdf"
            />
            <Form.File.Label
              data-browse={t(
                "SingleExamination.InstanceTab.PaperNotesDialog.UploadButton"
              )}
            />
          </Form.File>
        </Form>
      ) : (
        ""
      );
    const loading =
      !this.props.hasPaperNotes && this.state.isLoading ? (
        <div>
          <FontAwesomeIcon icon={faCircleNotch} spin />{" "}
          {t("SingleExamination.InstanceTab.PaperNotesDialog.Loading")}
        </div>
      ) : (
        ""
      );
    return (
      <>
        <ConfirmationDialog
          title={t(
            "SingleExamination.InstanceTab.PaperNotesDialog.ConfirmTitle"
          )}
          body={t(
            "SingleExamination.InstanceTab.PaperNotesDialog.ConfirmQuestion"
          )}
          show={this.state.showConfirmationDialog}
          dialogApiError={this.state.dialogApiError}
          onHide={() =>
            this.setState({
              dialogApiError: "",
              showConfirmationDialog: false
            })
          }
          onSubmit={this.handleRemove}
          confirmButtonVariant="red"
          cancelButtonVariant="black"
        />
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  {t("SingleExamination.InstanceTab.PaperNotesDialog.Title")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {this.state.dialogApiError}
                {upload}
                {loading}
                {paperNotes}
              </Modal.Body>
              <Modal.Footer>
                <Button className="btn btn-black"  onClick={this.props.onHide}>
                    {t("DialogClose")}
                </Button>
              </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withTranslation()(ManagePaperNotes);
